import titleize from 'underscore.string/titleize';

angular.module('filters').filter('titleize', function() {
  return function(data) {
    return titleize(data);
  };
});
